module.exports = __webpack_public_path__ + "static/media/Brios-Cereales-Descripcion-Mobile.26ea18ed.webp";